import React from 'react'
import '../../css/box.css'

const boxStyle = {
  background: 'white'
}

class Box extends React.Component {

  render() {
    const { bgcolor } = this.props
    if (bgcolor) boxStyle.background = bgcolor
    const boxClass =  'box ' + (this.props.className ? this.props.className : '')

    return (
      <div className={boxClass} style={boxStyle}>{this.props.children}</div>
    )
  }
}

export default Box



// WEBPACK FOOTER //
// ./src/components/widgets/Box.js